<template>
  <BaseDialog :is-open="isOpen" disable-click-outside>
    <div class="mb-4 flex items-center text-warning">
      <IconExclamationTriangleFilled class="mr-2 size-8" />
      <h2 class="text-xl font-semibold">
        WebView update recommended
      </h2>
    </div>

    <div class="space-y-3 text-background-fg/87">
      <p>
        Your Android System WebView version is older than
        recommended. Some UI elements may not display
        correctly.
      </p>

      <div class="rounded bg-background-fg/8 p-3 text-sm">
        <p>
          <span class="font-semibold"
            >Current version:</span
          >
          {{ currentVersion ?? "Unknown" }}
        </p>
        <p>
          <span class="font-semibold"
            >Recommended version:</span
          >
          {{ minimumVersion }}+
        </p>
      </div>

      <p class="text-sm">
        For the best experience, please update Android
        System WebView. Please contact
        {{ organizationName }} for assistance in doing this.
      </p>
    </div>

    <div class="mt-5 flex flex-col">
      <ActionButtonPrimary @click="emit('acknowledge')">
        Continue anyway
      </ActionButtonPrimary>
      <ActionButtonSecondary
        v-if="canExit"
        class="mt-3"
        @click="() => App.exitApp()"
      >
        Exit app
      </ActionButtonSecondary>
    </div>
  </BaseDialog>
</template>

<script setup lang="ts">
import { App } from "@capacitor/app"
import { IconExclamationTriangleFilled } from "@/icons"
import { MINIMUM_WEBVIEW_VERSION } from "@/utils/webViewVersionCheck"
import { useOrganizationConfig } from "@/services/organizations/retrieveOrganizationConfig"

defineProps<{
  isOpen: boolean
  currentVersion?: string
}>()

const emit = defineEmits<{
  acknowledge: []
}>()

const { organizationConfig } = useOrganizationConfig()

const minimumVersion = MINIMUM_WEBVIEW_VERSION
const canExit = import.meta.env.VITE_PLATFORM !== "web"

const organizationName = computed(
  () =>
    organizationConfig.value?.organizationName ??
    "takepayments"
)
</script>
